import { Special } from '@common/entities';

import { AddonOption } from 'types/addon';

export type SaveOptionsPageFn = (
  newPageIndex: number,
  addOns: AddonOption[],
  selectedSpecials?: Special[],
) => Promise<void>;

export interface CreatePersistAddOnsHandlerParams {
  activeStepIndex: number;
  saveOptionPage: SaveOptionsPageFn;
  isPreviewMode: boolean;
}

/**
 * Wraps options-page save with preview skip, loading flag, and boolean success for callers.
 */
export function createPersistAddOnsHandler({
  activeStepIndex,
  saveOptionPage,
  isPreviewMode,
}: CreatePersistAddOnsHandlerParams) {
  return async function persistAddOns(addOns: AddonOption[]): Promise<boolean> {
    if (isPreviewMode) return true;
    try {
      await saveOptionPage(activeStepIndex, addOns);
      return true;
    } catch {
      return false;
    }
  };
}
